import React from 'react'
import { Field } from 'formik'
import { Form, Col } from '_zari/core'

const TamanioFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TAMAÑO' htmlFor='input-tamanio' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='tamanio'>
          {({ field }) => (
            <Form.InputText
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='input-tamanio'
              placeholder='Tamaño del producto'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TamanioFormGroup)
